import { render, staticRenderFns } from "./BulletAsset.vue?vue&type=template&id=4d11f9b4&scoped=true"
import script from "./BulletAsset.vue?vue&type=script&lang=ts"
export * from "./BulletAsset.vue?vue&type=script&lang=ts"
import style0 from "./BulletAsset.vue?vue&type=style&index=0&id=4d11f9b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d11f9b4",
  null
  
)

export default component.exports